import { Component } from '@angular/core';

@Component({
  selector: 'df-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent {

}
